import * as React from "react";
import { classNames, getClassNamesForLogicalAttribute } from "../uitk-react-utils/index.js";
import {
  UitkCardContentSectionBorders,
  UitkCardTags
} from "./types.js";
export function UitkCardContentSection({
  border,
  children,
  className,
  padded = true,
  padding,
  tag,
  ...attributes
}) {
  let link;
  const newChildren = [];
  const Tag = tag && UitkCardTags.get(tag) || UitkCardTags.get("div");
  React.Children.forEach(children, (child) => {
    if (!child) {
      return;
    }
    switch (child.type.displayName) {
      case "UitkCardLink":
        link = child;
        break;
      default:
        newChildren.push(child);
    }
  });
  const baseClass = "uitk-card-content-section";
  const paddingSize = padding ?? (padded ? "medium" : "none");
  const paddingClassNames = getClassNamesForLogicalAttribute(paddingSize, `${baseClass}-padding`);
  const cssClassNames = classNames(
    baseClass,
    border && `${baseClass}-border-${UitkCardContentSectionBorders.get(border)}`,
    link && `${baseClass}-has-link`,
    paddingClassNames,
    className
  );
  return /* @__PURE__ */ React.createElement(Tag, { ...attributes, className: cssClassNames }, newChildren, link);
}
;
UitkCardContentSection.displayName = "UitkCardContentSection";
export const UitkCardAlohaContentSection = UitkCardContentSection;
